import {KeyboardTypeOptions, StyleSheet, TextInput, View} from 'react-native';
import React from 'react';
import {Sizes, TextStyles, Colors, TextAlign} from '../index';
import {InputPill} from './InputPill';
import {ComponentProps} from './ComponentProps';

interface InputTextProps extends ComponentProps {
  onTextChanged: (text: string) => void;
  text?: string | null;
  textAlign?: TextAlign;
  placeholder?: string;
  autoFocus?: boolean;
  capitalize?: 'none' | 'words' | 'characters' | 'sentences' | undefined;
  autoCorrect?: boolean;
  // default: true
  isValid?: boolean;
  // default: true
  isEnabled?: boolean;
  iconLeft?: JSX.Element;
  defaultValue?: string;
  keyboardType?: KeyboardTypeOptions;
}

export const InputText = (props: InputTextProps) => {
  const textInputStyle = [
    styles.textInput,
    TextStyles.textMediumM,
    {
      color: props.isValid ?? true ? Colors.neutralDarkAlpha : Colors.error,
      textAlign: props.textAlign ?? 'left',
    },
  ];
  const isEnabled = props.isEnabled ?? true;
  return (
    <InputPill {...{...props, borderColor: Colors.neutralLightAlpha}}>
      {props.iconLeft && <View style={styles.iconLeft}>{props.iconLeft}</View>}
      <TextInput
        testID={props.testID}
        style={textInputStyle}
        placeholder={props.placeholder}
        placeholderTextColor={Colors.neutralLight}
        autoFocus={props.autoFocus}
        onChangeText={props.onTextChanged}
        autoCapitalize={props.capitalize ?? 'none'}
        autoCorrect={props.autoCorrect ?? false}
        defaultValue={props.defaultValue}
        pointerEvents={isEnabled ? 'auto' : 'none'}
        keyboardType={props.keyboardType}
        value={props.text ? props.text : undefined}
      />
    </InputPill>
  );
};

const styles = StyleSheet.create({
  iconLeft: {marginRight: Sizes.xs},
  textInput: {
    flex: 1,
  },
});
